import React, { Component } from "react";
import validator from "validator";
import { PageMode } from "../../../../../utils/constant";

export default class Effort extends Component {

  submit = (e) => {
    e.preventDefault();
    if (this.props.mode === PageMode.add) {

      if (
        validator.isEmpty(this.props.data.date_investigation.value) ||
        validator.isEmpty(this.props.data.health_service_description.value) ||
        validator.isEmpty(this.props.data.date_net_distribution.value) ||
        validator.isEmpty(this.props.data.net_number.value) ||
        validator.isEmpty(this.props.data.date_last_irs.value) ||
        validator.isEmpty(this.props.data.number_houses_irs.value) ||
        validator.isEmpty(this.props.data.date_last_mbs.value) ||
        validator.isEmpty(this.props.data.number_of_people_mbs.value) ||
        validator.isEmpty(this.props.data.types_of_mosquito_breeding.value)
      ) {
        this.setState({
          error: true,
        });
        toast.error("Input Wajib Diisi tidak boleh kosong", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        this.props.onSave();
      }
    } else {
      this.props.onSave();
    }
  };


  render() {
    const {
      data,
      onInputChange,
      onSave,
      onBack
    } = this.props;
    return (
      <div className="form-wrapper">
        <div className="form-title">
          <p className="font-weight-bold">
            Upaya Pengedalian Larva yang pernah dilakukan
          </p>
        </div>
        <div className="form-group">
          <label htmlFor="attempt">
            Pilih upaya <sup className="text-danger">*</sup>
          </label>
          <select
            name="attempt"
            id="attempt"
            className="form-control"
            value={data.attempt.value || ""}
            onChange={onInputChange}
          >
            <option value="">
              Pilih
            </option>
            <option value="Tidak Ada">Tidak Ada</option>
            <option value="Larvasidasi">Larvasidasi</option>
            <option value="Penebaran Ikan">Penebaran Ikan</option>
            <option value="Modifikasi Lingkungan">Modifikasi Lingkungan</option>
            <option value="Manipulasi Lingkungan">Manipulasi Lingkungan</option>
          </select>
        </div>
        <div className="form-group">
          <p className="font-weight-bold">IRS</p>
          <label htmlFor="date_irs">
            Tanggal IRS
            <sup className="text-danger">*</sup>
          </label>
          <input
            type="date"
            className="form-control"
            name="date_irs"
            id="date_irs"
            value={data.date_irs.value || ""}
            onChange={onInputChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="number_of_targeted_house_irs">
            Jumlah Rumah Sasaran
            <sup className="text-danger">*</sup>
          </label>
          <input
            type="numberOnly"
            className="form-control"
            name="number_of_targeted_house_irs"
            id="number_of_targeted_house_irs"
            placeholder="0"
            value={data.number_of_targeted_house_irs.value || ""}
            onChange={onInputChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="number_of_houses_sprayed">
            Jumlah Rumah Yang disemprot
            <sup className="text-danger">*</sup>
          </label>
          <input
            type="numberOnly"
            className="form-control"
            name="number_of_houses_sprayed"
            id="number_of_houses_sprayed"
            placeholder="0"
            value={data.number_of_houses_sprayed.value || ""}
            onChange={onInputChange}
          />
        </div>
        <div className="form-group">
          <p className="font-weight-bold">Kelambu</p>
          <label htmlFor="net_distribution_date">
            Tanggal Distribusi kelambu
            <sup className="text-danger">*</sup>
          </label>
          <input
            type="date"
            className="form-control"
            name="net_distribution_date"
            id="net_distribution_date"
            value={data.net_distribution_date.value || ""}
            onChange={onInputChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="number_of_targeted_house_net">
            Jumlah rumah sasaran (kelompok tidur)
            <sup className="text-danger">*</sup>
          </label>
          <input
            type="numberOnly"
            className="form-control"
            name="number_of_targeted_house_net"
            id="number_of_targeted_house_net"
            placeholder="0"
            value={data.number_of_targeted_house_net.value || ""}
            onChange={onInputChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="number_of_distributed_net">
            Jumlah kelambu yang dibagikan
            <sup className="text-danger">*</sup>
          </label>
          <input
            type="numberOnly"
            className="form-control"
            name="number_of_distributed_net"
            id="number_of_distributed_net"
            placeholder="0"
            value={data.number_of_distributed_net.value || ""}
            onChange={onInputChange}
          />
        </div>
        <div className="form-group">
          <p className="font-weight-bold">Pengendalian Larva</p>
          <label htmlFor="date_activities">
            Tanggal Dilaksanakan
            <sup className="text-danger">*</sup>
          </label>
          <input
            type="date"
            className="form-control"
            name="date_activities"
            id="date_activities"
            value={data.date_activities.value || ""}
            onChange={onInputChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="activities_name">
            Jenis Kegiatan
            <sup className="text-danger">*</sup>
          </label>
          <select
            name="activities_name"
            id="activities_name"
            className="form-control"
            value={data.activities_name.value || ""}
            onChange={onInputChange}
          >
            <option value="">
              Pilih
            </option>
            <option value="Tidak Ada">Tidak Ada</option>
            <option value="Larvasidasi">Larvasidasi</option>
            <option value="Penebaran Ikan">Penebaran Ikan</option>
            <option value="Modifikasi Lingkungan">Modifikasi Lingkungan</option>
            <option value="Manipulasi Lingkungan">Manipulasi Lingkungan</option>
          </select>
        </div>
        <div className="form-group">
          <p className="font-weight-bold">KIE</p>
          <label htmlFor="kie_activities_name">Jenis Kegiatan</label>
          <select
            name="kie_activities_name"
            id="kie_activities_name"
            className="form-control"
            value={data.kie_activities_name.value || ""}
            onChange={onInputChange}
          >
            <option value="">
              Pilih
            </option>
            <option value="Advokasi">Advokasi</option>
            <option value="Sosialisasi">Sosialisasi</option>
            <option value="Pemberdayaan Masyarakat">Pemberdayaan Masyarakat</option>
            <option value="Lainnya">Lainnya</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="other">Lainnya*</label>
          <input type="text" className="form-control" />
        </div>
        <div className="form-action d-flex justify-content-end">
          <button
            className="btn btn-teal-outline font-weight-bold mr-2"
            onClick={onBack}
          >
            Kembali
          </button>
          <button
            className="btn btn-teal font-weight-bold"
            onClick={onSave}
          >
            Simpan
          </button>
        </div>
      </div>
    );
  }
}
